export const STORE_RESET_PASSWORD_TOKEN = "STORE_RESET_PASSWORD_TOKEN";
export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_CURRENT_WORKSPACE = "SET_CURRENT_WORKSPACE";
export const SET_STORED_AREA = "SET_STORED_AREA";
